export default __webpack_public_path__ + "static/media/079-st-barts.dff2d84f.svg";